
export const ACTIONS_TYPES = Object.freeze({
  
  LOGOUT_REQUEST: 'logout-request',

  // Login Action Types
  LOGIN_REQUEST: 'login-request',
  LOGIN_SUCCESS: 'login-success',
  LOGIN_FAILED: 'login-failed',
  LOGIN_RESET: 'login-reset',

  //configs
  APP_CONFIGS_REQUEST: 'app-configs-request',
  APP_CONFIGS_SUCCESS: 'app-configs-success',
  APP_CONFIGS_FAILED: 'app-configs-failed',

  //project
  FETCH_PROJECTS_REQUEST: 'fetch-projects-request',
  FETCH_PROJECTS_SUCCESS: 'fetch-projects-success',
  FETCH_PROJECTS_FAILED: 'fetch-projects-failed',

  // register project
  REGISTER_PROJECT_REQUEST: 'register-project-request',
  REGISTER_PROJECT_FAILED: 'register-project-failed',
  REGISTER_PROJECT_SUCCESS: 'register-project-success',
  REGISTER_PROJECT_RESET: 'register-project-reset',

  SUSPEND_PROJECT_REQUEST: 'suspend-project-request',
  SUSPEND_PROJECT_FAILED: 'suspend-project-failed',
  SUSPEND_PROJECT_SUCCESS: 'suspend-project-success',
  SUSPEND_PROJECT_RESET: 'suspend-project-reset',


  //companies
  FETCH_COMPANIES_REQUEST: 'fetch-companies-request',
  FETCH_COMPANIES_SUCCESS: 'fetch-companies-success',
  FETCH_COMPANIES_FAILED: 'fetch-companies-failed',

  // register company
  REGISTER_COMPANY_REQUEST: 'register-company-request',
  REGISTER_COMPANY_FAILED: 'register-company-failed',
  REGISTER_COMPANY_SUCCESS: 'register-company-success',
  REGISTER_COMPANY_RESET: 'register-company-reset',

  SUSPEND_COMPANY_REQUEST: 'suspend-company-request',
  SUSPEND_COMPANY_FAILED: 'suspend-company-failed',
  SUSPEND_COMPANY_SUCCESS: 'suspend-company-success',
  SUSPEND_COMPANY_RESET: 'suspend-company-reset',



  // job cards
  CREATE_JOB_CARD_REQUEST: 'create-job-card-request',
  CREATE_JOB_CARD_FAILED: 'create-job-card-failed',
  CREATE_JOB_CARD_SUCCESS: 'create-job-card-success',
  CREATE_JOB_CARD_RESET: 'create-job-card-reset',

  FETCH_JOBCARDS_REQUEST: 'fetch-jobcards-request',
  FETCH_JOBCARDS_SUCCESS: 'fetch-jobcards-success',
  FETCH_JOBCARDS_FAILED: 'fetch-jobcards-failed',
  FETCH_JOBCARDS_RESET: 'fetch-jobcards-reset',

  VIEW_JOB_REQUEST: 'view-job-request',
  VIEW_JOB_SUCCESS: 'view-job-success',
  VIEW_JOB_FAILED:  'view-job-failed',

  FETCH_MY_WORKSPACE_JOBCARDS_REQUEST: 'fetch-my-workspace-jobcards-request',
  FETCH_MY_WORKSPACE_JOBCARDS_SUCCESS: 'fetch-my-workspace-jobcards-success',
  FETCH_MY_WORKSPACE_JOBCARDS_FAILED: 'fetch-my-workspace-jobcards-failed',

  // register user
  REGISTER_USER_REQUEST: 'register-user-request',
  REGISTER_USER_FAILED: 'register-user-failed',
  REGISTER_USER_SUCCESS: 'register-user-success',
  REGISTER_USER_RESET: 'register-user-reset',
  // workspace - pending meter activation
  METER_ACTIVATION_REQUEST: 'meter-activation-request',
  METER_ACTIVATION_SUCCESS: 'meter-activation-success',
  METER_ACTIVATION_FAILED : 'meter-activation-failed',

  //workspace - awaiting contractor
  ASSIGN_CONTRACTOR_REQUEST: 'assign-contractor-request',
  ASSIGN_CONTRACTOR_SUCCESS: 'assign-contractorsuccess',
  ASSIGN_CONTRACTOR_FAILED: 'assign-contractor-failed',

  //workspace - awaiting contractor
  ASSIGN_INSPECTOR_COMPANY_REQUEST: 'assign-inspector-company-request',
  ASSIGN_INSPECTOR_COMPANY_SUCCESS: 'assign-inspector-company-success',
  ASSIGN_INSPECTOR_COMPANY_FAILED: 'assign-inspector-company-failed',
  
  //workspace - awaiting contractor
  ASSIGN_TECHNICIAN_REQUEST: 'assign-technician-request',
  ASSIGN_TECHNICIAN_SUCCESS: 'assign-technician-success',
  ASSIGN_TECHNICIAN_FAILED: 'assign-technician-failed',

      // register meter
  REGISTER_METER_REQUEST: 'register-meter-request',
  REGISTER_METER_FAILED: 'register-meter-failed',
  REGISTER_METER_SUCCESS: 'register-meter-success',
  REGISTER_METER_RESET: 'register-meter-reset',

   //workspace - management-decision
   MANAGEMENT_DECISION_REQUEST: 'management-decision-request',
   MANAGEMENT_DECISION_SUCCESS: 'management-decision-success',
   MANAGEMENT_DECISION_FAILED: 'management-decision-failed',

   //workspace - awaiting-inspector
   AWAITING_INSPECTOR_REQUEST: 'awaiting-inspector-request',
   AWAITING_INSPECTOR_SUCCESS: 'awaiting-inspector-success',
   AWAITING_INSPECTOR_FAILED: 'awaiting-inspector-failed',

   //workspace - quality-control
   QUALITY_CONTROL_REQUEST: 'quality-control-request',
   QUALITY_CONTROL_SUCCESS: 'quality-control-success',
   QUALITY_CONTROL_FAILED: 'quality-control-failed',

  //workspace - failed-execution
   FAILED_EXECUTION_REQUEST: 'failed-execution-request',
   FAILED_EXECUTION_SUCCESS: 'failed-execution-success',
   FAILED_EXECUTION_FAILED: 'failed-execution-failed',
   
   MY_WORKSPACE_RESET:'my-workspace-reset',

   // users
  FETCH_USERS_REQUEST: 'fetch-users-request',
  FETCH_USERS_SUCCESS: 'fetch-users-success',
  FETCH_USERS_FAILED: 'fetch-users-failed',
  FETCH_USERS_RESET: 'fetch-users-reset',

  // meters
  FETCH_METERS_REQUEST: 'fetch-meters-request',
  FETCH_METERS_SUCCESS: 'fetch-meters-success',
  FETCH_METERS_FAILED: 'fetch-meters-failed',
  FETCH_METERS_RESET: 'fetch-meters-reset',

  SUSPEND_USER_REQUEST: 'suspend-user-request',
  SUSPEND_USER_FAILED: 'suspend-user-failed',
  SUSPEND_USER_SUCCESS: 'suspend-user-success',
  SUSPEND_USER_RESET: 'suspend-user-reset',

  GET_JOB_AUDITS_REQUEST: 'get-job-audits-request',
  GET_JOB_AUDITS_FAILED: 'get-job-audits-failed',
  GET_JOB_AUDITS_SUCCESS: 'get-job-audits-success',
});